function updateCartCounter(count) {
  var counterElements = document.querySelectorAll(".cart-counter");
  counterElements.forEach(function (counterElement) {
    counterElement.textContent = "" + count + "";
  });
}

// Function to fetch cart data and update the counter
function updateCartCounterFromAPI() {
  theme.cart.getCart().then(function (cartData) {
    var itemCount = cartData.item_count || 0;
    updateCartCounter(itemCount);
  });
}

// Listen for cart updates and update the counter
document.addEventListener("cart:updated", function (event) {
  var itemCount = event.detail.cart.item_count || 0;
  updateCartCounter(itemCount);
});

document.addEventListener("ajaxProduct:added", () => {
  updateCartCounterFromAPI();
});


/* === 3HD phone fixes (added Oct 2026): readable cart drawer, smaller floating buttons on phones, sticky Add to Cart === */
(function(){
  var css = ".drawer .cart__item-name { color:#111 !important; font-weight:700; }\n.drawer .cart__item .text-link { color:#c41e1e !important; }\n.drawer .js-qty__adjust, .drawer .js-qty__num { color:#111 !important; }\nhtml.js-drawer-open #hd-yard, html.js-drawer-open .hd-txmini, html.js-drawer-open .hd-sticky-atc { display:none !important; }\n@media (max-width: 767px) {\n  .hd-txmini { display:none !important; }\n  #hd-yard { left:10px !important; bottom:10px !important; width:38px; height:38px; padding:0 !important; justify-content:center; border-radius:50%; opacity:.8 !important; }\n  #hd-yard span { display:none !important; }\n  #hd-yard i { width:10px !important; height:10px !important; }\n  body.hd-has-sticky #hd-yard { bottom:78px !important; }\n  .hd-sticky-atc { position:fixed; left:0; right:0; bottom:0; z-index:997; display:flex !important; align-items:center; gap:10px; padding:10px 12px calc(10px + env(safe-area-inset-bottom)); background:rgba(10,10,10,.96); border-top:2px solid #c41e1e; transform:translateY(110%); transition:transform .25s ease; }\n  .hd-sticky-atc.show { transform:translateY(0); }\n  .hd-sticky-atc .hd-sa-info { flex:1; min-width:0; color:#f2ede4; font:700 13px/1.2 Arial,sans-serif; }\n  .hd-sticky-atc .hd-sa-info span { display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }\n  .hd-sticky-atc .hd-sa-info em { font-style:normal; color:#c41e1e; }\n  .hd-sticky-atc button { flex:0 0 auto; background:#c41e1e; color:#fff; border:0; padding:13px 18px; font:900 13px/1 Arial,sans-serif; letter-spacing:.12em; text-transform:uppercase; cursor:pointer; }\n  body.hd-has-sticky .main-content { padding-bottom:70px; }\n}\n";
  function run(){
    var st=document.createElement('style'); st.id='hd-mobile-fixes'; st.textContent=css; document.head.appendChild(st);
    if (!/\/products\//.test(location.pathname)) return;
    var real = document.querySelector('form.product-single__form button.add-to-cart, form[action*="/cart/add"] button[name="add"]');
    if (!real) return;
    var titleEl = document.querySelector('.product-single__title, h1');
    var priceEl = document.querySelector('span.product__price');
    var bar = document.createElement('div'); bar.className = 'hd-sticky-atc';
    var info = document.createElement('div'); info.className = 'hd-sa-info';
    var t = document.createElement('span'); t.textContent = titleEl ? titleEl.textContent.trim() : '';
    var p = document.createElement('em');
    var btn = document.createElement('button'); btn.type = 'button'; btn.textContent = 'Add to cart';
    info.appendChild(t); info.appendChild(p); bar.appendChild(info); bar.appendChild(btn);
    document.body.appendChild(bar); document.body.classList.add('hd-has-sticky');
    function sync(){ if (priceEl) p.textContent = priceEl.textContent.trim().split(/\s+/)[0]; btn.disabled = real.disabled; btn.textContent = real.disabled ? 'Sold out' : 'Add to cart'; }
    sync();
    new MutationObserver(sync).observe(real, {attributes:true, childList:true, subtree:true});
    if (priceEl) new MutationObserver(sync).observe(priceEl, {childList:true, subtree:true, characterData:true});
    btn.addEventListener('click', function(){ real.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ bar.classList.toggle('show', !es[0].isIntersecting); }).observe(real);
    } else { bar.classList.add('show'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
